import React from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";

const TimeType = () => {

    const config: MasterConfigs = {
        api: () => '/time-type',
        title: 'Time Type',
        modalTitle: () => 'Time Type',
        getColumns: () => [
            {
                title: 'Time Type',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Code',
                dataIndex: 'code',
                key: 'code',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: '50%',
                ellipsis: true
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
            }
        ],
        getFormColumns: () => [
            {
                label: 'Time Type',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Time Type' }]
            },
            {
                label: 'Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            },
        ],
        actions: [{ actionType: 'Add', name: 'Add Time Type' }]
    }

    return <MasterComponent config={config} />
}
export default TimeType;